
import Vue from 'vue';
import { CvSearch, CvButton } from '@carbon/vue';

export default Vue.extend({
  components: {
    CvSearch,
    CvButton,
  },
  data() {
    return {
      criteria: '',
    };
  },
  methods: {
    onInput(criteria: string) {
      if (!criteria && criteria !== this.criteria) {
        this.$emit('search', criteria);
      }
      this.criteria = criteria;
    },
  },
});
